/**
 * Maps a P `event_type` string to a stable i18n message key. Unknown types
 * fall back to the drilling label so the UI never shows a raw code.
 */
import type { EventOut } from "@api/types";
import type { MessageKey } from "@i18n/messages";

export type { EventOut };

export type MessageEventTypeKey = Extract<MessageKey, `eventType.${string}`>;

const MAP: Record<string, MessageEventTypeKey> = {
  drilling: "eventType.drilling",
  completion: "eventType.completion",
  workover: "eventType.workover",
  intervention: "eventType.intervention",
};

export function eventTypeKey(ev: EventOut): MessageEventTypeKey {
  return MAP[ev.event_type.toLowerCase()] ?? "eventType.drilling";
}
